module.exports = __webpack_public_path__ + "img/default.e1551498.png";